import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Col,
  Input,
  InputNumber,
  Row,
  Form,
  Select,
  Button,
  Flex,
  TreeSelect,
  DatePicker,
  Checkbox,
  Switch,
} from "antd";

export const _layout = {
  labelCol: {
    span: 24,
    padding: 0,
  },
  wrapperCol: {
    span: 24,
    padding: 0,
  },
};

const { SHOW_CHILD, SHOW_ALL, SHOW_PARENT } = TreeSelect;

export const initiateFormItem = (item) => {
  switch (item?.type) {
    case "number":
      return (
        <Form.Item
          name={item?.name}
          label={item?.label}
          rules={item.rules}
          labelCol={item.labelCol}
          wrapperCol={item.wrapperCol}
        >
          <InputNumber
            style={{ width: "100%" }}
            disabled={item.disabled}
          ></InputNumber>
        </Form.Item>
      );

    case "text":
      return (
        <Form.Item
          name={item?.name}
          label={item?.label}
          rules={item.rules}
          labelCol={item.labelCol}
          wrapperCol={item.wrapperCol}
        >
          <Input
            allowClear
            disabled={item.disabled}
            maxLength={item.maxLength}
            showCount={item.maxLength}
          ></Input>
        </Form.Item>
      );

    case "select":
      return (
        <Form.Item
          name={item?.name}
          label={item?.label}
          rules={item.rules}
          labelCol={item.labelCol}
          wrapperCol={item.wrapperCol}
        >
          <Select
            style={{ width: "100%" }}
            options={item.options}
            maxCount={item.maxCount}
            mode={item.multiple ? "multiple" : ""}
            disabled={item.disabled}
            onChange={item.onChange}
            showSearch={item.showSearch}
            allowClear
            loading={item.loading}
          ></Select>
        </Form.Item>
      );

    case "tree":
      return (
        <Form.Item
          name={item?.name}
          label={item?.label}
          rules={item.rules}
          labelCol={item.labelCol}
          wrapperCol={item.wrapperCol}
          tooltip={item.tooltip}
        >
          <TreeSelect
            style={{ width: "100%" }}
            multiple={item.multiple}
            allowClear
            disabled={item.disabled}
            treeCheckable={item.checkable}
            showSearch={item.showSearch}
            showCheckedStrategy={
              !item.showCheckedStrategy
                ? SHOW_ALL
                : item.showCheckedStrategy == "child"
                ? SHOW_CHILD
                : item.showCheckedStrategy == "parent"
                ? SHOW_PARENT
                : SHOW_ALL
            }
            treeData={item.options}
            onChange={item.onChange}
            loading={item.loading}
            filterTreeNode={(input, treeNode) => {
              const match = (treeNode?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase());
              return match;
            }}
            tagRender={item.tagRender ?? null}
          ></TreeSelect>
        </Form.Item>
      );

    case "datetime":
      return (
        <Form.Item
          name={item?.name}
          label={item?.label}
          rules={item.rules}
          labelCol={item.labelCol}
          wrapperCol={item.wrapperCol}
          tooltip={item.tooltip}
        >
          <DatePicker
            needConfirm={false}
            disabled={item.disabled}
            style={{ width: "100%" }}
            showTime={!item.isDateOnly}
            showHour
            showMinute
            // defaultValue={item.value}
            // value={item.value}
            showSecond={item.showSecond ? true : false}
            onPanelChange={(value, mode) => {}}
            minDate={item?.minDate}
            maxDate={item?.maxDate}
            onChange={item.onChange}
            picker={item?.picker ? item?.picker : "date"}
          ></DatePicker>
        </Form.Item>
      );

    case "checkbox":
      return (
        <Form.Item
          name={item?.name}
          label={item?.label}
          rules={item.rules}
          labelCol={item.labelCol}
          wrapperCol={item.wrapperCol}
        >
          <Checkbox disabled={item.disabled} />
        </Form.Item>
      );

    case "switch":
      return (
        <Form.Item
          name={item?.name}
          label={item?.label}
          rules={item.rules}
          labelCol={item.labelCol}
          wrapperCol={item.wrapperCol}
        >
          <Switch disabled={item.disabled} />
        </Form.Item>
      );

    default:
      return (
        <Input
          allowClear
          maxLength={item.maxLength}
          showCount={item.maxLength}
        ></Input>
      );
  }
};

export default function CustomFormItemsHorizontal({
  layout = _layout,
  form,
  config = [],
  onFinish,
  submitIcon,
  submitText,
  resetFilter,
}) {
  const clearForm = () => {
    form.resetFields();

    // Call resetFilter only if it's defined
    if (typeof resetFilter === "function") {
      resetFilter();
    }
  };

  return (
    <>
      <Form form={form} {...layout} onFinish={onFinish}>
        <Row gutter={[18, 0]}>
          {config?.map((item, idx) => (
            <Col
              key={idx}
              {...(item?.colspan
                ? item.colspan
                : {
                    xs: 24,
                    sm: 24,
                    md: 24,
                    lg: 12,
                    xl: 6,
                    xxl: 6,
                  })}
            >
              {initiateFormItem(item)}
            </Col>
          ))}
          <Col span={24}>
            <Flex justify="end" align="center" gap="middle">
              <Button
                type="default"
                icon={<CloseOutlined />}
                onClick={() => clearForm()}
              >
                Clear
              </Button>
              <Button type="primary" htmlType="submit" icon={submitIcon}>
                {submitText}
              </Button>
            </Flex>
          </Col>
        </Row>
      </Form>
    </>
  );
}
